module.exports = __webpack_public_path__ + "img/arrowup.26d88ded.svg";